import './OverflowTriggerPopover.css';

import { IonIcon, IonItem, IonList, IonPopover } from '@ionic/react';
import { PredefinedColors } from '@ionic/core';
import Button from '../Button/Button';
import ArrowIcon from '../ArrowIcon/ArrowIcon';
import NestedPopoverItems from './components/NestedPopoverItems';

export interface OverflowItem {
  key: string;
  label: string;
  icon?: string;
  onClick?: () => void;
  disabled?: boolean;
  /** When present, the item opens a nested popover listing these children instead of firing onClick. */
  children?: OverflowItem[];
}

interface OverflowTriggerPopoverProps {
  triggerId: string;
  label: string;
  items: OverflowItem[];
  triggerColor?: PredefinedColors;
  arrowColor?: 'primary' | 'dark';
  /** Disables the trigger button itself (popover cannot be opened). */
  disabled?: boolean;
}

const OverflowTriggerPopover = ({
  triggerId,
  label,
  items,
  triggerColor,
  arrowColor = 'primary',
  disabled = false,
}: OverflowTriggerPopoverProps) => (
  <div>
    <Button
      id={triggerId}
      className="dataset-additional-buttons-trigger"
      fill="clear"
      color={triggerColor}
      round={false}
      disabled={disabled}
    >
      <ArrowIcon direction="down" color={arrowColor} />
      {label}
    </Button>
    <IonPopover
      trigger={triggerId}
      alignment="start"
      dismissOnSelect={true}
      showBackdrop={false}
    >
      {/* Plain scrollable div, not IonContent: IonContent inside IonPopover
          ignores mouse-wheel scrolling on desktop. */}
      <div className="overflow-popover-content">
        <IonList>
          {items.map((item, itemIndex) => {
            const lines = itemIndex === items.length - 1 ? 'none' : 'full';

            if (item.children && item.children.length > 0) {
              const nestedId = `${triggerId}-sub-${item.key.replace(/\W/g, '')}`;
              return (
                <NestedPopoverItems
                  key={item.key}
                  item={item}
                  nestedId={nestedId}
                  lines={lines}
                />
              );
            }

            return (
              <IonItem
                button={true}
                onClick={item.onClick}
                disabled={item.disabled}
                key={item.key}
                lines={lines}
              >
                {item.icon && <IonIcon icon={item.icon} slot="start" />}
                {item.label}
              </IonItem>
            );
          })}
        </IonList>
      </div>
    </IonPopover>
  </div>
);

export default OverflowTriggerPopover;
